const NEW_ZEALAND_ORIGIN = 'https://wiperpro.co.nz';

class FooterCountrySwitcher extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.currentCountry = this.querySelector('[data-footer-country-current]');
    this.newZealandLink = this.querySelector('[data-footer-country-target]');
    this.menuItems = Array.from(this.querySelectorAll('[role="menuitem"]'));

    if (!this.details || !this.summary || !this.newZealandLink) {
      this.initialized = false;
      return;
    }

    this.newZealandLink.href = this.getNewZealandUrl();
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleToggle = this.handleToggle.bind(this);

    this.details.addEventListener('toggle', this.handleToggle);
    this.addEventListener('keydown', this.handleKeydown);
    this.currentCountry?.addEventListener('click', () => this.closeMenu());
    document.addEventListener('click', this.handleDocumentClick);
    this.handleToggle();
  }

  disconnectedCallback() {
    this.details?.removeEventListener('toggle', this.handleToggle);
    this.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener('click', this.handleDocumentClick);
  }

  getNewZealandUrl() {
    const alternate = document.querySelector(
      'link[rel="alternate"][hreflang="en-NZ"]'
    );

    if (alternate?.href) {
      try {
        const alternateUrl = new URL(alternate.href);

        if (alternateUrl.origin === NEW_ZEALAND_ORIGIN) {
          return alternateUrl.toString();
        }
      } catch (_error) {
        // Ignore malformed or untrusted alternates and use the safe fallback.
      }
    }

    if (window.location.pathname === '/search') {
      const query = new URLSearchParams(window.location.search).get('q');

      if (query) {
        const searchUrl = new URL('/search', NEW_ZEALAND_ORIGIN);
        searchUrl.searchParams.set('q', query);
        return searchUrl.toString();
      }
    }

    return `${NEW_ZEALAND_ORIGIN}/`;
  }

  handleToggle() {
    this.summary?.setAttribute(
      'aria-expanded',
      this.details?.open ? 'true' : 'false'
    );
  }

  handleDocumentClick(event) {
    if (this.details?.open && !this.contains(event.target)) {
      this.closeMenu(false);
    }
  }

  handleKeydown(event) {
    const currentIndex = this.menuItems.indexOf(document.activeElement);

    if (event.key === 'Escape' && this.details?.open) {
      event.preventDefault();
      this.closeMenu();
      return;
    }

    if (event.target === this.summary && event.key === 'ArrowDown') {
      event.preventDefault();
      this.details.open = true;
      this.menuItems[0]?.focus();
      return;
    }

    if (currentIndex < 0) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.menuItems[(currentIndex + 1) % this.menuItems.length]?.focus();
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.menuItems[
        (currentIndex - 1 + this.menuItems.length) % this.menuItems.length
      ]?.focus();
    } else if (event.key === 'Home') {
      event.preventDefault();
      this.menuItems[0]?.focus();
    } else if (event.key === 'End') {
      event.preventDefault();
      this.menuItems[this.menuItems.length - 1]?.focus();
    }
  }

  closeMenu(restoreFocus = true) {
    if (!this.details) return;

    this.details.open = false;
    if (restoreFocus) this.summary?.focus();
  }
}

if (!customElements.get('footer-country-switcher')) {
  customElements.define('footer-country-switcher', FooterCountrySwitcher);
}
